export const DISCOUNT_PRICE_COLOR = '#F00';
export const INCREDIBLE_DISCOUNTS_PRICE_COLOR = '#399F26';
export const DEFAULT_ERROR_MESSAGE = 'Ai atins cantitatea maxima';
export const MAX_QUANTITY_REACHED_TOAST_ID = 'maxQuantityReachedToast';
// export const SGR_BAG_SKU = '100141901'; // QA
export const SGR_BAG_SKU = '100184640'; // Prod
